interface StatCardProps {
	label: string;
	value: string;
	description?: string;
}

/**
 * A single stat card for displaying a metric
 */
export function StatCard({ label, value, description }: StatCardProps) {
	return (
		<div className="rounded-xl border border-base-content/10 bg-base-100 p-6">
			<div className="text-sm font-medium text-base-content/60">{label}</div>
			<div className="mt-2 text-3xl font-bold text-base-content">{value}</div>
			{description && (
				<div className="mt-1 text-xs text-base-content/50">{description}</div>
			)}
		</div>
	);
}
